import { useQuery } from '@tanstack/react-query';

import { BUSINESS_DASHBOARD_MAX_PAGES } from '~/consts/businessTraveller';

import { getActivityLog } from '~/services/BusinessTraveller/BusinessTravellerService';

export function silverGrantsQueryOptions(businessId: string) {
  return {
    queryKey: ['business-traveller', 'silver-grants', businessId],
    queryFn: async ({ signal }: { signal: AbortSignal }) => {
      const silverGrantDates: Record<string, string> = {};
      const unknownEmployeeIds = new Set<string>();
      for (let page = 0; page < BUSINESS_DASHBOARD_MAX_PAGES; page++) {
        if (signal.aborted) throw signal.reason;
        const response = await getActivityLog(
          businessId,
          { page, pageSize: 100 },
          {
            resource: 'Societe',
            operation: 'TierUpgrade',
            sort: 'createdAt',
            sortDirection: 'desc',
          },
        );
        for (const log of response.result) {
          const details = log.details as { accountSummary?: { tier?: string } };
          const tier = details?.accountSummary?.tier;
          if (!tier) unknownEmployeeIds.add(log.employeeId);
          if (tier === 'silver' && !silverGrantDates[log.employeeId]) {
            silverGrantDates[log.employeeId] = new Date(log.createdAt).toISOString();
          }
        }
        if (
          !response.result.length ||
          (response.meta ? (page + 1) * 100 >= response.meta.total : response.result.length < 100)
        )
          return { silverGrantDates, unknownEmployeeIds: Array.from(unknownEmployeeIds) };
      }
      throw new Error('Silver grant history exceeded the dashboard page limit.');
    },
    staleTime: 60_000,
    retry: false,
  };
}

export function useLebtSilverGrants(businessId: string) {
  return useQuery(silverGrantsQueryOptions(businessId));
}
